import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { useRef, useState } from 'react';
import { Input } from '../../../components/common/Input/index.js';
import { validateEmail } from '../../../helpers/validateEmail.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { accountIdentifierEmailSelector, updateAccountIdentifierEmail, updateEmailError, updateEmailErrorMessage, } from '../accountIdentifierSlice.js';
import { clearAuthError } from '../../../redux/core/authError/authErrorSlice.js';
import { hotjarEvent } from '../../../tracking/hotjar/index.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
export const EmailAddressInput = () => {
    const { t } = useTranslation();
    const accountIdentifierEmail = useAppSelector(accountIdentifierEmailSelector);
    const [isInteraction, setIsInteraction] = useState(false);
    const dispatch = useAppDispatch();
    const inputRef = useRef(null);
    const { trackFieldError } = useTrack('twoStep');
    const onBlurEmail = ({ target: { value }, }) => {
        if (!isInteraction) {
            return;
        }
        setIsInteraction(false);
        const emailString = value;
        const hasError = !validateEmail(emailString);
        dispatch(updateEmailError(hasError));
        if (hasError) {
            dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
            trackFieldError({ formFieldErrors: 'emailAddressNotValid' });
        }
    };
    const emailOnChange = ({ target: { value }, }) => {
        if (!value.length) {
            dispatch(updateEmailError(false));
            setIsInteraction(false);
        }
        else {
            setIsInteraction(true);
            validateEmail(value) && dispatch(updateEmailError(false));
        }
        dispatch(clearAuthError());
        dispatch(updateAccountIdentifierEmail(value));
    };
    const { value, error, errorMessage } = accountIdentifierEmail;
    const onFocus = () => {
        hotjarEvent('2-step-email-input-focused');
    };
    return (_jsx(Input, { dataTestId: "email-input", value: value, onChange: emailOnChange, onFocus: onFocus, type: 'email', name: 'email', formLabel: t('loginregistration.twoStepLoginRegistration.email.headerInput'), placeholder: t('loginregistration.twoStepLoginRegistration.email.placeholder'), hasError: error, errorText: errorMessage, onBlur: onBlurEmail, autoComplete: 'username', ref: inputRef }));
};
//# sourceMappingURL=EmailAddressInput.js.map